import { z } from 'zod';

import { zodContactLinkSchema } from '../validations';

/**
 * Zod schema for the GET /data_exchange/contact_link/all query parameters.
 */
export const zodContactLinksQueryParamsSchema = z.object({
  limit: z.number().int().gte(1).prefault(500),
  offset: z.number().int().gte(0).prefault(0),
});

/**
 * Zod schema for the paginated contact links response (PaginatedContactLink).
 */
export const zodContactLinksResponseSchema = z.object({
  items: z.array(zodContactLinkSchema),
  nextLink: z.string(),
});
